export const environment = {
  local: false,
  development: true,
  production: false,
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyDmymgvCC_yjnNvrGvDOCl6xUBwlPMVe8I',
    authDomain: 'carvry-dev.firebaseapp.com',
    projectId: 'carvry-dev',
    storageBucket: 'carvry-dev.appspot.com',
    messagingSenderId: '209073515658',
    appId: '1:209073515658:web:67cd7d095797c1679b9173',
    measurementId: 'G-GJSRBP9S19',
    databaseURL: 'https://carvry-dev-default-rtdb.firebaseio.com'
  },
  loggingUrl: 'https://dev-bff.carvry.com/v1/utilities/logging',
  reCaptchaSiteKey: '6LfCiHYbAAAAAN0fBkIZF4RAvirHbHf4VlzwijUw',
  contentful: {
    environment: 'dev',
    space: '5q7gesg0nu8t',
    accessToken: 'jCkNY4wuGf4dAETGMF0vL1Qa7ou-GuEvydm4P-fjWr0'
  },
  facebookAppId: '375279787547729',
  baseUrl: 'https://dev.carvry.com',
  mlUtilitiesUrl: 'https://dev-ml-utilities.carvry.com/v1/api',
  apiUrl: 'https://dev-bff.carvry.com/v1',
  vapidKey: 'BBZ2VH8fcVB0lGYb6Z0GixBZE51w3uzH5Vat62AezZ2mCviYIWYos4RmOMyH8enyf4bULQgQ7JfTrzHu43LNM_U',
  stripeKey: 'pk_test_51RRYZ9GL8AXqiRYBPRejkSnImWTG1e30xfdYIxMJlkYIEHjDNSiChr2ombpe9UynTjAy5vfiufkwD4EQbQf7jf7O00o53VShet',
  preRenderToken: 'zEczl5nLimGf7dTDwn1I'
};
